// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","greyCell":"ZRsPBdOFgWeE40lhAoDjC","statusTablesWrapper":"_29JV41XHmhlEQXdBKdrDKf","listItem":"_19RsPkqsGZbYwkhcFHb1Zm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/libraryStatus/Status.css
// module id = 115
// module chunks = 0